
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#8CD1D0"}}),_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M29.325 15.068a.485.485 0 00-.047-.21.46.46 0 00-.322-.252l-8.095-3.892a.484.484 0 00-.417 0l-8.174 3.928a.474.474 0 00-.27.41v9.877a.47.47 0 00.27.425l8.174 3.928c.004 0 .004 0 .008.004.012.004.024.008.036.016.004 0 .008.004.016.004l.035.012c.005 0 .008.004.012.004.012.004.028.004.04.008h.012l.052.003c.016 0 .035 0 .051-.003h.012a.145.145 0 00.04-.008c.004 0 .008-.004.012-.004l.036-.012c.004 0 .008-.004.016-.004a.139.139 0 00.035-.016c.004 0 .004 0 .008-.004l8.198-3.94a.476.476 0 00.27-.425v-9.838c-.008-.004-.008-.008-.008-.011zm-8.674-3.404l7.089 3.407-2.61 1.257-7.09-3.408 2.61-1.256zm0 6.815l-7.09-3.408 3.386-1.627 7.09 3.408-3.386 1.627zm-7.697-2.647l7.22 3.47V28.1l-7.22-3.47v-8.798zM21.128 28.1v-8.797l3.39-1.631v2.3a.476.476 0 00.953 0v-2.761l2.9-1.395v8.798L21.129 28.1z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(12 10.667)","d":"M0 0h17.333v18.667H0z"}})])])])
          )
        }
      }
    